import { render } from "./widget-notebook-1.vue?vue&type=template&id=66484c44"
import script from "./widget-notebook-1.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-notebook-1.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-card/widgets/widget-notebook-1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66484c44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66484c44', __exports__)) {
    api.reload('66484c44', __exports__)
  }
  
  module.hot.accept("./widget-notebook-1.vue?vue&type=template&id=66484c44", () => {
    api.rerender('66484c44', render)
  })

}


export default __exports__